<template>
  <div>
    <AverageStats v-if="type == 0" :title="title" :data="data" />
    <GroupStats v-if="type == 1" :title="title" :groups="data" />
    <PieCharts v-if="type == 2" :title="title" :dataChart="data" :options="options" />
    <VerticalBarChart v-if="type == 3" :title="title" :dataChart="data" :options="options" />
  </div>
</template>

<script src="./js/displayStatType.js"></script>